import { Component, OnInit, NgZone } from '@angular/core';
import { ControlQrService } from 'src/app/_services/control-qr.service';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';
import html2canvas from 'html2canvas';
import * as pdfMake from 'pdfmake/build/pdfmake';
import * as pdfFonts from 'pdfmake/build/vfs_fonts';
import { GlobalService } from 'src/app/_services/global.service';
import { TranslateService } from '@ngx-translate/core';
import { AutoUnsubscribe } from 'src/app/shared/decorators/auto-unsubscribe.decorator';
import { Subject, takeUntil } from 'rxjs';
pdfMake.vfs = pdfFonts.pdfMake.vfs;
declare var $: any;
@AutoUnsubscribe
@Component({
  selector: 'app-qr-modal',
  templateUrl: './qr-modal.component.html',
  styleUrls: ['./qr-modal.component.scss']
})
export class QrModalComponent implements OnInit {
  parent;
  pivot;
  schoolName: string;
  schoolImage: string
  hoverFlag = false;
  cardType = 'single';
  parents: [];
  parentsWithCompletedProfile = [];
  parentsWithNonCompletedProfile = [];
  privewCards = false;
  imageToPrint = [];
  pages = [];
  groups = [];
  currLang;
  destroy$ = new Subject<void>(); 


  constructor(private qrControl: ControlQrService,
    private router: Router,
    private _ngZone: NgZone,
    private globalService: GlobalService,
    private translate: TranslateService,
  ) {
    this.globalService.getLang().pipe(takeUntil(this.destroy$)).subscribe(lng => {
      this.currLang = lng;
      this.translate.use(this.currLang);
    });
  }

  ngOnInit(): void {
    $(document).on('hidden.bs.modal', '#qrModal', () => {
      this.cancelModalHandler();
    })

    this.globalService.getLang().pipe(takeUntil(this.destroy$)).subscribe(lng => {
      this.currLang = lng;
      this.translate.use(this.currLang);
    });

    this.hoverFlag = false;
    this.schoolName = localStorage.getItem('schoolName');
    this.schoolImage = environment.img_url + localStorage.getItem('schoolImage');
    this.qrControl.getParentData().pipe(takeUntil(this.destroy$)).subscribe((res: any) => {
      if (res.parent !== undefined) {
        this.parent = res.parent;
        this.pivot = res.parent.pivot;
        if (this.pivot === undefined) {
          this.pivot = res.parent.schools[0].pivot;
        }
        this.cardType = res.type;
      }
    })

    this.qrControl.getParentsData().pipe(takeUntil(this.destroy$)).subscribe((res: any) => {
      if (res.noOfParents !== undefined && res.type === 'multi') {
        this.parentsWithNonCompletedProfile = [];
        this.parentsWithCompletedProfile = [];
        this.parents = this.parentsWithNonCompletedProfile = res.noOfParents;
        this.cardType = res.type;
        // commented to print registered parents
        // this.parents.map((parent: any) => {
        //   this.parentsWithNonCompletedProfile.push(parent);
        //   if (parent.is_completed_profile === 1) {
        //     this.parentsWithCompletedProfile.push(parent);
        //   }
        //   else {
        //     this.parentsWithNonCompletedProfile.push(parent);
        //   }
        // })
      }
      this.groups = this.parentsWithNonCompletedProfile.map((e, i) => {
        return i % 10 === 0 ? this.parentsWithNonCompletedProfile.slice(i, i + 10) : null;
      }).filter(e => { return e; });
    })
  }

  getParentImage() {
    if (this.parent !== undefined) {
      return environment.img_url + this.parent.image_path;
    }
  }

  getQrImage() {
    if (this.pivot !== undefined) {
      return environment.img_url + this.parent.qr_code;
    }
  }

  getImage(image) {
    return environment.img_url + image;
  }

  getQrImageMultiParent(parent) {
    let qr_code = parent.qr_code ? parent.qr_code : parent.schools[0].pivot.qr_code;
    return environment.img_url + qr_code;
  }

  showOverlay() {
    this.hoverFlag = true;
  }

  hideOverlay() {
    this.hoverFlag = false;
  }

  printQR() {
    this._ngZone.runOutsideAngular(() => {
      html2canvas(document.querySelector('#print-card'), { logging: true, allowTaint: false, useCORS: true }).then(canvas => {
        const imgData = canvas.toDataURL('image/jpeg', 1);
        const documentDefinition = this.getDocumentDefinition(imgData);
        pdfMake.createPdf(documentDefinition).print();
      });
    })
  }

  printMultiQR() {
    // debugger
    for (let i = 0; i < this.parentsWithNonCompletedProfile.length; i++) {
      // debugger
      let id = `#print-card-more${i+1}`;
      // let test=document.querySelector(id);
      // debugger
      html2canvas(document.querySelector(id), { logging: true, allowTaint: false, useCORS: true }).then(canvas => {
        // debugger
        const imgData = canvas.toDataURL('image/jpeg', 1);
        this.imageToPrint.push(imgData);
        if (i == this.parentsWithNonCompletedProfile.length - 1) {
          // debugger
          const documentDefinition = this.getDocumentDefinition2(this.imageToPrint);
          pdfMake.createPdf(documentDefinition).print();
        }
      });
      
    }
  }

  showCards() {
    this.privewCards = true;
  }

  getDocumentDefinition(imgData) {
    let qrContent =
      [
        {
          pageSize: 'A4',
          image: imgData,
          margin: [-25, -35, -25, -14],
          fit: [150, 300],
        }
      ]

    return {
      pageSize: 'A4',
      pageOrientation: 'Landscape',
      content: qrContent
    }
  }

  getDocumentDefinition2(imgData) {
    if (imgData.length == 1) {
      return {
        pageSize: 'A4',
        pageOrientation: 'Landscape',
        content: [
          {
            pageSize: 'A4',
            pageOrientation: 'landscape',
            image: imgData[0],
            margin: [-25, -35, -25, -14],
            fit: [141.73, 255.12],
          },
        ]
      }
    } else {
      imgData.forEach(element => {
        let page = {
          pageSize: 'A4',
          pageOrientation: 'landscape',
          image: element,
          margin: [-25, -35, -25, -14],
          fit: [141.73, 255.12],
          pageBreak: 'after',
        }
        this.pages.push(page);
      });
      return {
        pageSize: 'A4',
        pageOrientation: 'landscape',
        content: this.pages
      }
    }
  }

  cancelModalHandler() {
    this.hoverFlag = false;
    this.privewCards = false;
    this.parents = [];
    this.parentsWithCompletedProfile = [];
    this.parentsWithNonCompletedProfile = [];
    this.groups = [];
    this.pages = [];
    this.cardType = 'single';
    this.imageToPrint = [];
    // this.destroy$.next();
    // this.destroy$.complete();
  }

  ngOnDestroy() { 
  }
}
